import { useState } from 'react'
import { Link } from 'react-router-dom'
import useSWR from 'swr'
import { api, fetcher } from '../api/client'

export default function ProspectsPage() {
    const [search, setSearch] = useState('')
    const [vertical, setVertical] = useState('')
    const [industry, setIndustry] = useState('')
    const [creating, setCreating] = useState(false)

    const qs = new URLSearchParams()
    if (search) qs.set('search', search)
    if (vertical) qs.set('vertical', vertical)
    if (industry) qs.set('industry', industry)

    const { data, mutate } = useSWR<any>(`/api/prospects?${qs}`, fetcher)

    return (
        <div>
            <div className="row">
                <h1 style={{ margin: 0 }}>Prospects</h1>
                <div className="grow"></div>
                <button onClick={() => setCreating(true)}>+ New Prospect</button>
            </div>

            <div className="card">
                <div className="row">
                    <input className="grow" placeholder="Search name or company..." value={search} onChange={e => setSearch(e.target.value)} data-testid="search-input" />
                    <input placeholder="Vertical" value={vertical} onChange={e => setVertical(e.target.value)} />
                    <input placeholder="Industry" value={industry} onChange={e => setIndustry(e.target.value)} />
                </div>
            </div>

            {creating && <CreateProspectForm onClose={() => { setCreating(false); mutate() }} />}

            <div className="card">
                {!data ? <p className="muted">Loading...</p> :
                    data.items?.length === 0 ? <p className="muted">No prospects yet. Try the <Link to="/discover">Discover</Link> page or add one manually.</p> :
                        <>
                            <p className="muted">{data.total} prospects</p>
                            <table>
                                <thead><tr><th>Name</th><th>Title</th><th>Company</th><th>Industry</th><th>Score</th></tr></thead>
                                <tbody>
                                    {data.items.map((p: any) => (
                                        <tr key={p.id}>
                                            <td><Link to={`/prospects/${p.id}`}>{p.name}</Link></td>
                                            <td>{p.title ?? '—'}</td>
                                            <td>{p.company}</td>
                                            <td className="muted">{p.industry ?? '—'}</td>
                                            <td>{p.leadScore != null ? <span className="score">{p.leadScore}</span> : '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                }
            </div>
        </div>
    )
}

function CreateProspectForm({ onClose }: { onClose: () => void }) {
    const [form, setForm] = useState({
        name: '', title: '', email: '', company: '',
        industry: '', vertical: '', linkedInUrl: '', companyWebsite: '', notes: ''
    })
    const [err, setErr] = useState<string | null>(null)
    const [busy, setBusy] = useState(false)

    async function save(e: React.FormEvent) {
        e.preventDefault()
        setBusy(true); setErr(null)
        try {
            await api('/api/prospects', { method: 'POST', body: JSON.stringify(form) })
            onClose()
        } catch (e: any) {
            setErr(e.message)
        } finally {
            setBusy(false)
        }
    }

    return (
        <form onSubmit={save} className="card">
            <h2>New Prospect</h2>
            <div className="split">
                {(['name', 'title', 'email', 'company', 'industry', 'vertical', 'linkedInUrl', 'companyWebsite'] as const).map(k => (
                    <div className="form-row" key={k}>
                        <label>{k}</label>
                        <input
                            required={k === 'name' || k === 'company'}
                            value={(form as any)[k]}
                            onChange={e => setForm({ ...form, [k]: e.target.value })}
                            data-testid={`new-${k}`}
                        />
                    </div>
                ))}
            </div>
            <div className="form-row">
                <label>Notes</label>
                <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
            </div>
            {err && <div className="error">{err}</div>}
            <div className="row">
                <button type="submit" disabled={busy}>Save</button>
                <button type="button" className="secondary" onClick={onClose}>Cancel</button>
            </div>
        </form>
    )
}
